import './styles.scss';
import React, {useState} from 'react';
import ContractsTable from "../../components/specific/Contracts.table/Contracts.table.component";
import {useQuery} from "react-query";
import ContractApi from "../../api/Contract/Contract.api";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import ContractFilters from "../../components/specific/Contracts.filters/Contracts.filters";
import {Collapse} from "antd";
import ContractsFilterManager from "../../components/specific/Contracts.filters/Contracts.filters.manager";
import ContractsAnalytics from "../../components/specific/Contracts.analytics/Contracts.analytics.component";
import PlaceholderSearch from "../../components/common/Placeholder.search/Placeholder.search.component";
import ContractsTotals from "../../components/specific/Contracts.graphs/Contracts.graphs.totals";
import {SearchOutlined} from "@ant-design/icons";


function ContractReportsContainer() {
    const [query, setQuery] = useState<any>(getLocalStorageQuery());
    const [page, setPage] = useState(1);
    const [collapsed, setCollapsed] = useState(ContractsFilterManager.initialQuerySent);

    const {
        isLoading,
        data,
        isFetched
    } = useQuery(
        ['fetchContracts', {...query, page}],
        ContractApi.getContracts, {enabled: ContractsFilterManager.initialQuerySent}
    );

    const {
        isLoading: isLoadingAnalytics,
        data: analyticsData,
        isIdle
    } = useQuery(
        ['fetchContractAnalytics', {...query}],
        ContractApi.getContractAnalytics, {enabled: isFetched}
    );

    function onPagination(page: number) {
        setPage(page);
    }


    function renderAnalytics() {
        if (isIdle) {
            return null;
        }
        if (isLoadingAnalytics || !analyticsData) {
            return (
                <div style={{marginBottom: 24}}>
                    <DefaultLoader text='Loading analytics...'/>
                </div>
            )
        } else {
            return (
                <div className='analytics-container'>
                    <ContractsTotals data={analyticsData.rankedVendors.data}/>
                    <ContractsAnalytics analytics={analyticsData}/>
                </div>
            );
        }
    }

    function renderContractsTable() {
        if (isLoading || !data?.records) {
            return (
                <div className='default-loader-full'>
                    <DefaultLoader text='Loading contracts...'/>
                </div>
            )
        } else {
            const pagination = {
                onChange: onPagination,
                pageSize: 25,
                total: Math.trunc(data.totalRecords),
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                current: page,
                position:['topRight'] as any,
                showSizeChanger: false,
            }
            return (
                <div className='contract-reports-container-content-table'>
                    <ContractsTable data={data.records} pagination={pagination}/>
                </div>
            )
        }
    }

    function onSubmitQuery(values: any) {
        let serializedQuery = ContractsFilterManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .setInitialQuerySent()
            .getValues();
        setQuery(serializedQuery);
        setCollapsed(true);
    }

    function getLocalStorageQuery() {
        return ContractsFilterManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getContractsFiltersInitialValues() {
        return ContractsFilterManager
            .setSerializedValues(getLocalStorageQuery())
            .deserializeQuery()
            .getValues()
    }

    function renderContent() {
        if (!ContractsFilterManager.initialQuerySent) {
            return <PlaceholderSearch text="Change Search Criteria to Search Contracts"/>
        } else {
            return (
                <>
                    {renderAnalytics()}
                    {renderContractsTable()}
                </>
            )
        }
    }

    function onCollapseChange(keys){
        if (keys.indexOf("1") !== -1){
            setCollapsed(false);
        } else {
            setCollapsed(true);
        }
    }


    return (
        <div className='contract-reports-container'>
            <div className='contract-reports-container-header'>
                <div className='title'>
                    Contracts
                </div>
                <div className='filters'>
                    <Collapse ghost activeKey={collapsed ? null : 1} onChange={onCollapseChange} expandIconPosition='right'>
                        <Collapse.Panel key={1} header={<div className='global-search-criteria-dropdown-header'><SearchOutlined/>Edit Search Criteria</div>}>
                            <ContractFilters onSubmitQuery={onSubmitQuery}
                                             initialValues={getContractsFiltersInitialValues()}/>
                        </Collapse.Panel>
                    </Collapse>
                </div>
            </div>
            <div className='contract-reports-container-content'>
                {renderContent()}
            </div>
        </div>
    )
}

export default ContractReportsContainer;